import * as React from 'react';

interface GenBreadcumbProp {
  title: string;
  key: string;
  onClick: () => void;
}
interface GenBreadcrumbsProps {
  breadcrumbs: Array<GenBreadcumbProp>
}

export default function GenBreadcrumbs(props: GenBreadcrumbsProps) {
  const breadcrumbs = props.breadcrumbs.map((breadcrumb) => {
    return <a key={breadcrumb.key} onClick={breadcrumb.onClick}>{breadcrumb.title}</a>;
  });

  return(
    <div className="gen-breadcrumbs">
      {breadcrumbs}
    </div>
  );
}
